const STACK_ID = 'eduzz-ui-version-stack';
const POPOVER_STACK_ID = 'eduzz-ui-version-popover-stack';

export function getVersionStackContainer(): HTMLElement {
  let element = document.getElementById(STACK_ID);

  if (!element) {
    element = document.createElement('div');
    element.id = STACK_ID;
    element.className = 'eduzz-ui-version-stack';
    document.body.appendChild(element);
  }

  return element;
}

export function getVersionPopoverStackContainer(): HTMLElement {
  let element = document.getElementById(POPOVER_STACK_ID);

  if (!element) {
    element = document.createElement('div');
    element.id = POPOVER_STACK_ID;
    element.className = 'eduzz-ui-version-popover-stack';
    document.body.appendChild(element);
  }

  return element;
}
